import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "components/Modal/Modal";
import Button from "components/buttons/Button";
import OperationsDetailsTab from "../../tabs/transactions/operations/OperationsDetailsTab";
import OperationsLedgerTab from "../../tabs/transactions/operations/OperationsLedgerTab";
import { useAppDispatch } from "store";
import { closeModal } from "store/modals/slice";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ModalOperationsTabs } from "configs/types";
import styles from "./PaymentTransactionsOperationsEditModal.module.scss"

const PaymentTransactionsOperationsEditModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const operationId = Number(searchParams.get("operationId"));

  const tabs = [ModalOperationsTabs.details, ModalOperationsTabs.ledger];

  const [activeTab, setActiveTab] = useState<ModalOperationsTabs>(
    ModalOperationsTabs.details,
  );

  const renderTab = () => {
    if (activeTab === ModalOperationsTabs.details) {
      return <OperationsDetailsTab operationId={operationId} />;
    }

    if (activeTab === ModalOperationsTabs.ledger) {
      return <OperationsLedgerTab />;
    }

    return null;
  };

  const handleCloseClick = () => {
    navigate(`${location.pathname}`);
    dispatch(closeModal());
  };

  return (
    <Modal onClose={handleCloseClick}>
      <Modal.Header>{t("operationInfo")}</Modal.Header>

      <Modal.Tabs
        tabs={tabs}
        activeTab={activeTab}
        onClick={(tab) => setActiveTab(tab)}
      />

      <Modal.Content
        className={styles.paymentTransactionsOperationContentWrapper}
      >
        {renderTab()}
      </Modal.Content>

      <Modal.Footer>
        <Button isSecondary txt={t("close")} handleClick={handleCloseClick} />
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentTransactionsOperationsEditModal;
